import React from 'react'
import { Text, LabelValue, InfoPill, constants } from '@adc/ui-core'
import classnames from 'classnames/bind'
import cls from './styles.scss'

const cx = classnames.bind(cls)

const { ColorNames } = constants

const Place: { [key: number]: string } = {
  1: '1st',
  2: '2nd',
  3: '3rd',
  4: '4th',
}

type OfferAmountHeaderProps = {
  amount: number
  title?: string
  formattedPaymentType?: string
  place?: number
  elmId?: string
  offerRankingInfoPillOverride?: React.ReactNode
  className?: string
  isMobile?: boolean
}

const OfferAmountHeader = ({
  title = 'Purchase Price',
  formattedPaymentType = '',
  amount,
  place,
  elmId = 'offer-amount-header',
  offerRankingInfoPillOverride = null,
  className,
  isMobile,
}: OfferAmountHeaderProps) => {
  const rankPlace: string = Place[place ?? 0]
  return (
    <div className={cx('container', className)}>
      <div className={cx('inline-flex-align-bottom')}>
        <LabelValue
          elmId={elmId}
          value={amount}
          label={title}
          level={1}
          isMoneyValue
        />
        {formattedPaymentType && !isMobile && (
          <div>
            <InfoPill
              size='small'
              content={formattedPaymentType}
              includeBorder
              backgroundColor={ColorNames.SuccessLight}
              foregroundColor={ColorNames.Success}
              iconName='money-bill'
              elmId={`${elmId}-payment-type-info-pill`}
            />
          </div>
        )}
      </div>
      {offerRankingInfoPillOverride || (
        <InfoPill // this fallback InfoPill exists to preserve backwards functionality, but the offerRankingInfoPillOverride is for the new component which will contain place logic AND other status based messaging which will show in this location
          size='small'
          backgroundColor={ColorNames.SuccessLight}
          foregroundColor={ColorNames.Success}
          includeBorder
          iconName='award'
          extraPadding='small'
          elmId={`${elmId}-offer-ranking-info-pill`}
          label={
            <>
              <Text.Body as='div' size='small' color={ColorNames.Success}>
                {isMobile ? '' : 'This offer is currently in '}
                <b data-elm-id={`${elmId}_place_rank`}>{`${
                  rankPlace || `${String(place)}th`
                }`}</b>{' '}
                place
              </Text.Body>
            </>
          }
        />
      )}
    </div>
  )
}

export default OfferAmountHeader
